import { InfoTable } from "../../components/InfoTable/InfoTable.jsx";
import { IconCheck, IconTriangleAlert } from "../../components/Icon/Icon.jsx";
import { Panel } from "../../components/Panel/Panel.jsx";
import { PaneStack } from "../../components/PaneStack/PaneStack.jsx";
import { createBudgetSidebarData } from "./budgetSummary.js";

function decorateSidebarRows(rows) {
  return rows.map((row) => ({
    label: row.label,
    value: row.value,
    status: row.statusTone
      ? {
        tone: row.statusTone,
        content: row.statusTone === "good"
          ? <IconCheck />
          : <IconTriangleAlert />
      }
      : null
  }));
}

export function BudgetSidebar({ rows, expenseRows, dateContext, t = (key) => key }) {
  const sections = createBudgetSidebarData(rows, expenseRows, dateContext, t);

  return (
    <PaneStack fill distribute="equal">
      {sections.map((section) => (
        <Panel key={section.key} header={section.title} padded scroll>
          <InfoTable
            rows={decorateSidebarRows(section.rows)}
            labelWidth="7rem"
            frameless
          />
        </Panel>
      ))}
    </PaneStack>
  );
}
